import React from "react";
import { Table, Typography } from "antd";
import type { ColumnsType } from "antd/es/table";
import { Form } from "antd";

const { Title } = Typography;

interface DataType {
  key: string;
  sno: number;
  procedureCode: string;
  procedureReferral: string;
  procedureName: string;
  quantity: string; 
  treatingDoctor: string;
  accreditationStatus: string;
  amount: number;
  strats: any;
}

interface Props {
 form: any; // Add form prop
  isClaimStage?: boolean;
}

const AmountIncentiveDetails: React.FC<Props> = ({ form, isClaimStage = true }) => {
  const columns: ColumnsType<DataType> = [
    {
      title: "S.No.",
      dataIndex: "sno",
      key: "sno", 
      width: 70,
    },
    {
      title: "Procedure Code",
      dataIndex: "procedureCode",
      key: "procedureCode",
    },
    // {
    //   title: "Procedure Referral",
    //   dataIndex: "procedureReferral",
    //   key: "procedureReferral",
    // },
    {
      title: "Procedure Name",
      dataIndex: "procedureName",
      key: "procedureName",
    },
    {
      title: "Specialty",
      dataIndex: "specialty",
      key: "specialty",
    },
    {
      title: "Quantity/No. of Days",
      dataIndex: "quantity",
      key: "quantity"
    },
    // {
    //   title: "Treating Doctor",
    //   dataIndex: "treatingDoctor",
    //   key: "treatingDoctor"
    // },
    // {
    //   title: "Accreditation Status",
    //   dataIndex: "accreditationStatus", 
    //   key: "accreditationStatus"
    // },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (value) => `₹${value.toLocaleString("en-IN")}`,
    }
  ];

   const items = Form.useWatch('items', form);

  // Transform procedure data into table format
   const tableData: DataType[] = (items || []).map((item: any, index: number) => {
    const procedureDetails = item.procedureCode ? JSON.parse(item.procedureCode) : {};
    
    return {
      key: index.toString(),
      sno: index + 1,
      procedureCode: item.externalProcedureCode || '-',
      procedureReferral: item.procedureReferral?.split('~')?.[1] || '-',
      procedureName: procedureDetails?.procedureName || procedureDetails?.name || item.unspecifiedProcedureName || '-',
      quantity: item.numberOfDays || '0',
      treatingDoctor: item.treatingDoctor?.split('~')?.[1] || '-',
      accreditationStatus: item.accreditationStatus?.split('~')?.[1] || '-',
      amount: item.unspecifiedProcedureAmount 
        ? parseFloat(item.unspecifiedProcedureAmount) * parseFloat(item.numberOfDays)
        : parseFloat(item.procedureAmount || '0') * parseFloat(item.numberOfDays),
      strats: procedureDetails?.strats === "N" ? "N/A" : procedureDetails?.strats
    };
  });

  // Calculate total amount
  const totalAmount = tableData.reduce((sum, row) => sum + (row.amount || 0), 0);

  const css = `
    .amount-incentive-table .ant-table-thead > tr > th {
      background: #004c8f !important;
      color: #fff !important;
      vertical-align: middle;
    }
    .amount-incentive-section {
      // padding: 24px;
    }
    .amount-details {
      text-align: right;
      margin-top: 20px;
    }
    .amount-row {
      margin-bottom: 12px;
      font-size: 14px;
    }
    .amount-label {
      font-weight: 500;
      color: #666;
      margin-right: 12px;
    }
    .amount-value {
      font-weight: 600;
      color: #262626;
    }
  `;

  return (
    <div className="amount-incentive-section">
      <style>{css}</style>

      <div
        style={{
          textDecoration: "underline",
          fontSize: "18px",
          marginBottom: "6px",
          fontWeight: "bold",
          marginTop: "6px",
        }}
      >
        Amount & Incentive Details
      </div>

      <div style={{ marginBottom: 24 }}>
        <Table
          className="amount-incentive-table"
          columns={columns}
          dataSource={tableData}
          pagination={false}
          scroll={{ x: "max-content" }}
          bordered
          rowKey="key"
        />
      </div>

      <div className="amount-details">
        <div className="amount-row">
          <span className="amount-label">Total Amount:</span>
          <span className="amount-value">
            ₹{totalAmount.toLocaleString("en-IN")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default AmountIncentiveDetails;